import React, { useContext } from 'react';
import { Colors, Flex, useSafeArea } from '@banhala/ui-kit';
import { ScrollContext } from '../MarketHomeBanner/context/ScrollContext';
import Animated, {
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated';
import { ScrollToTopButton } from 'shared/src/component';

export const MarketHomeScrollToTop: React.FC = () => {
  const { bottom } = useSafeArea();

  const { scrollY, listRef } = useContext(ScrollContext);
  const style = useAnimatedStyle(() => {
    if (!scrollY) return {};

    return {
      width: 40,
      height: 40,
      borderRadius: 20,
      shadowColor: Colors.overlay_dark,
      shadowOffset: {
        width: 0,
        height: 1,
      },
      shadowOpacity: 0.12,
      shadowRadius: 1.41,

      elevation: 2,
      transform: [
        {
          translateY: interpolate(
            scrollY.value,
            [0, 300, 310],
            [100, 100, 0],
            'clamp',
          ),
        },
      ],
    };
  });

  return (
    <Flex position={'absolute'} right={16} bottom={16 + bottom}>
      <Animated.View style={style}>
        <ScrollToTopButton
          testID={'탑버튼'}
          onPress={() => {
            listRef?.current?.scrollToOffset({ offset: 0, animated: true });
          }}
        />
      </Animated.View>
    </Flex>
  );
};
